import { environment } from '@environments/environment';
import { ENVIRONMENTS } from '@shared/constants';

const isValidUUID = (untienotsId: string): boolean => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  return uuidRegex.test(untienotsId);
};

const isValidSha256 = (untienotsId: string): boolean => {
  const sha256Regex = /^[a-f0-9]{64}$/;
  return sha256Regex.test(untienotsId);
};

export const isUntienotsIdValid = (untienotsId: string): boolean => {
  if (
    environment.env == ENVIRONMENTS.DEV ||
    environment.env == ENVIRONMENTS.PLAYWRIGHT
  ) {
    // To facilitate work in dev
    return true;
  }
  if (!isValidUUID(untienotsId) && !isValidSha256(untienotsId)) {
    return false;
  }
  return true;
};
